import { render, staticRenderFns } from "./FreightTableConfigRoutesSection.vue?vue&type=template&id=350d9ba4&scoped=true"
import script from "./FreightTableConfigRoutesSection.vue?vue&type=script&lang=js"
export * from "./FreightTableConfigRoutesSection.vue?vue&type=script&lang=js"
import style0 from "./FreightTableConfigRoutesSection.vue?vue&type=style&index=0&id=350d9ba4&prod&scoped=true&lang=less"
import style1 from "./FreightTableConfigRoutesSection.vue?vue&type=style&index=1&id=350d9ba4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350d9ba4",
  null
  
)

export default component.exports